'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Set global slick settings, with a custom config for each instance
var slickSettings = function slickSettings(config) {
  var newConfiguration = config;
  var defaultSettings = {
    rows: 0,
    speed: 250,
    arrows: false,
    dots: false,
    customPaging: function customPaging(slider, i) {
      return '<div></div>';
    },
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><span class="icon icon-prev" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Previous" role="img" height="24" viewBox="0 0 15 24"><title>Previous</title><desc>Previous icon</desc><path d="M14.82 2.82L12 0 0 12l12 12 2.82-2.82L5.66 12z" class="fill"/></svg><span class="icon-fallback-text">Previous</span></span></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><span class="icon icon-next"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Next" role="img" height="24" viewBox="0 0 15 24"><title>Next</title><desc>Next icon</desc><path d="M.18 2.82L3 0l12 12L3 24 .18 21.18 9.34 12z" class="fill"/></svg><span class="icon-fallback-text">Next</span></span></button>'
  };

  return Object.assign({}, defaultSettings, newConfiguration);
};

exports.default = slickSettings;